import { render, staticRenderFns } from "./FixingList.vue?vue&type=template&id=2d20fab4&scoped=true"
import script from "./FixingList.vue?vue&type=script&lang=js"
export * from "./FixingList.vue?vue&type=script&lang=js"
import style0 from "./FixingList.vue?vue&type=style&index=0&id=2d20fab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d20fab4",
  null
  
)

export default component.exports